import bowser from 'yola-bowser';
import handleRemoveNextEmptyElement from '../helpers/handle-remove-next-empty-elements';
import handleRemoveImage from '../helpers/handle-remove-image';
import handleFirstEmptyElement from '../helpers/handle-first-empty-element';
import { BACKSPACE_KEY } from '../constants/keys';
import handleBackspaceOnListItemBeginning from '../helpers/handle-backspace-on-list-item-beginning';
import handleBeginningOfElement from '../helpers/handle-beginning-of-element';
import handlePreviousSiblingBreakingTag from '../helpers/handle-previous-sibling-breaking-tag';
import view from '../../view';
import canBeRichEdited from '../../constraints/verifiers/can-be-rich-edited';
import handleRemoveEmptyChildren from '../helpers/firefox-workarounds/handle-remove-empty-children';
import cleanFormatting from '../helpers/clean-formatting';
import isNodesFullySelected from '../verifiers/is-nodes-fully-selected';
import selectFromEnd from '../helpers/select-from-end';

const backspaceHandler = (e) => {
  if (e.key !== BACKSPACE_KEY) return;
  const closestEditableElement = e.srcElement.closest('[contenteditable]');

  if (!canBeRichEdited(closestEditableElement)) {
    return;
  }

  const selection = view.accessors.getSelection();

  // we need to clean custom elements such as [ws-decoration, ws-color]
  // to prevent browser native font creation with color on next input
  const { anchorNode, focusNode } = selection;
  const isCursorAfterSingleChar =
    anchorNode.parentNode === focusNode.parentNode && anchorNode.length === 1;

  if (isCursorAfterSingleChar || isNodesFullySelected()) {
    if (isCursorAfterSingleChar) {
      selectFromEnd(anchorNode, 0);
    }
    cleanFormatting();
  }

  if (!selection.isCollapsed) {
    if (bowser.firefox) {
      handleRemoveEmptyChildren();
    }

    handleRemoveNextEmptyElement();
    return;
  }

  const isImageRemoved = handleRemoveImage(e);
  if (isImageRemoved) return;

  const isListItemRemoved = handleBackspaceOnListItemBeginning(e);
  if (isListItemRemoved) return;

  const isFirstEmptyElementRemoved = handleFirstEmptyElement(e);
  if (isFirstEmptyElementRemoved) return;

  const isBreakTagRemoved = handlePreviousSiblingBreakingTag(e);
  if (isBreakTagRemoved) return;

  handleBeginningOfElement(e);
};

export default backspaceHandler;
